/**
 * API client for the system-events catalog, proxied through pro-api to user-service.
 */

import { authenticatedProApiFetch } from './pro-api.client';

export type SystemEventSourceService = 'user-service' | 'product-service';

export interface SystemEvent {
  id: string;
  key: string;
  label: string;
  description?: string | null;
  domain: string;
  historyType: string;
  shouldLog: boolean;
  enabled: boolean;
  sourceService: SystemEventSourceService | string;
  retiredAt?: string | null;
  subscribable?: boolean;
  subscriptionSummaryTemplate?: string | null;
  defaultSeverity?: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function fetchSystemEvents(
  token: string,
  opts?: {
    includeRetired?: boolean;
    sourceService?: string;
    search?: string;
    domain?: string;
  },
): Promise<SystemEvent[]> {
  const params = new URLSearchParams();
  if (opts?.includeRetired) params.set('includeRetired', 'true');
  if (opts?.sourceService) params.set('sourceService', opts.sourceService);
  if (opts?.search?.trim()) params.set('search', opts.search.trim());
  if (opts?.domain) params.set('domain', opts.domain);
  const qs = params.toString();
  return authenticatedProApiFetch<SystemEvent[]>(
    `/system-events${qs ? `?${qs}` : ''}`,
    token,
  );
}

export async function fetchSystemEvent(token: string, id: string): Promise<SystemEvent> {
  return authenticatedProApiFetch<SystemEvent>(`/system-events/${id}`, token);
}

export async function updateSystemEvent(
  token: string,
  id: string,
  data: Partial<{
    label: string;
    description: string | null;
    shouldLog: boolean;
    enabled: boolean;
    subscribable: boolean;
  }>,
): Promise<SystemEvent> {
  return authenticatedProApiFetch<SystemEvent>(`/system-events/${id}`, token, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function fetchSubscribableProductEvents(token: string): Promise<SystemEvent[]> {
  return authenticatedProApiFetch<SystemEvent[]>(
    '/system-events?subscribable=true&domain=product',
    token,
  );
}
